export const proximoPaso = (array, setPaso, dispatch) => {
  const paso = array.shift();
  setPaso(paso)(dispatch);
  return array;
};
export const proximoPasoLabo = (array) => {
  array.shift();
  return array;
};

export const EstaEnDim = (latitud, longitud, centros) => {
  let lat1 = toRad(latitud);
  let long1 = toRad(longitud);
  let resultado = [];
  let saveResultado = {};
  const radioEnKM = 5;

  for (let index = 0; index < centros.length; index++) {
    const element = centros[index];
    let lat2 = toRad(element.latitud);
    let long2 = toRad(element.longitud);

    let result =
      6377.830272 *
      Math.acos(
        Math.sin(lat1) * Math.sin(lat2) +
          Math.cos(lat1) * Math.cos(lat2) * Math.cos(long2 - long1)
      );

    if (result <= radioEnKM) {
      resultado.push(element);
      saveResultado[element.centro] = true;
    }
  }

  if (resultado.length > 0) {
    return resultado;
  } else {
    return false;
  }
};

// Función para convertir grados a radianes
const toRad = (grados) => {
  return (grados * Math.PI) / 180;
};

export const createRuta = (listaResumen) => {
  let ruta = [];
  listaResumen.map((element) => {
    if (!element.estado) ruta.push(element.path);
  });
  ruta.push("TurnoProximo");
  return ruta;
};

export const createListaResumen = (turno, resubirOrden) => {
  let lista = [
    {
      nombre: "Médico Solicitante ingresado",
      estado: turno?.medSolicitanteDto,
      path: "MedicoSolicitante",
      id: 1,
    },
    {
      nombre: "Validación Orden Medica",
      estado: turno.estadoOrden === "Validado",
      path: "SubirOrden",
      id: 2,
    },
    {
      nombre: "Autorización de orden",
      estado: turno.estadoOrden === "Validado",
      path: "RequiereAutorizacion",
      id: 3,
    },
    {
      nombre: "Validación con la cobertura",
      estado: turno?.validaOnlineEstado === "A",
      path: "ValidarCobertura",
      id: 4,
    },

    {
      nombre: "Abonar Turno",
      estado: turno?.flgSaldada,
      path: "AbonarMP",
      id: 5,
    },
  ];

  if (turno?.validaOnlineEstado === "R") {
    resubirOrden();
  }
  lista = lista.filter((element) => {
    if (turno?.monto <= 0 && element.id === 5) {
      return false;
    }
    if (
      (!turno.validaOnline && element.id === 4) ||
      (!turno.tieneDeterminaciones && element.id === 4)
    ) {
      return false;
    }
    if (
      (turno.flgSoloConsulta && element.id === 2) ||
      (turno.flgSoloConsulta && element.id === 1)
    )
      return false;
    if (
      (!turno.requiereAutorizacion && element.id === 3) ||
      (turno.flgSoloConsulta && element.id === 3)
    ) {
      return false;
    }
    return true;
  });

  return lista;
};

export const createListaResumenLabo = (turno) => {
  if (!turno.resumen.monto && turno?.resumen.validaOnline) {
    return [
      {
        nombre: "Validación con la cobertura",
        estado: turno?.resumen.validaOnlineEstado === "A",
        path: "validacionToken",
        id: 1,
      },
    ];
  } else if (turno.resumen.monto) {
    return [
      {
        nombre: "Abonar Turno",
        estado: turno?.resumen.flgSaldada,
        path: "AbonarMP",
        id: 2,
      },
    ];
  } else {
    return [];
  }
};
export const isPendiente = (misTurnos, turnosRecepcionados) => {
  if (misTurnos.length > turnosRecepcionados.length) {
    return true;
  } else {
    return false;
  }
};

export const listarCentros = (array) => {
  let centros;
  if (array.length > 0) {
    centros = array.map((element) => {
      let latitud = element.coordenadaGps.split(",")[0];
      let longitud = element.coordenadaGps.split(",")[1];
      return {
        centro: element.centro,
        latitud,
        longitud,
        idCentro: element.idCentro,
        idturno: element.idturno,
      };
    });
  }
  return centros;
};

export const setLoop = (cb) => {
  let interval = setInterval(() => cb(interval), 3000);
};

export const timeRecepcion = (horaLimite, tiempo, minutosExtra) => {
  // 17:10  17:32
  if (tiempo) {
    const date = new Date();
    const horaHoy = [date.getHours(), date.getMinutes()];
    horaLimite = horaLimite.split(":");

    let resultadoHora = Number(horaLimite[0]) - Number(horaHoy[0]);
    let resuladoMinutos = Number(horaLimite[1]) - Number(horaHoy[1]);
    let resultado = resultadoHora * 60 + resuladoMinutos;

    if (resultado < tiempo && resultado >= -minutosExtra) {
      return false;
    } else return true;
  }
};

export const msjPaciente = (listTurnos) => {
  let listaCorrectos = listTurnos.filter((e) => e.estado);
  if (listaCorrectos.length === listTurnos.length) return 2; // correcto
  else if (listaCorrectos.length > 0) return 1; // incompleto
  else return 0; // incorrecto
};

export const msjPacienteLabo = (listTurnos) => {
  listTurnos = listTurnos.filter((e) => e.path !== "validacionToken");
  let listaCorrectos = listTurnos.filter((e) => e.estado);
  let tieneOrden = listaCorrectos.filter((e) => e.path === "EscaneoOrden");
  tieneOrden = tieneOrden.length > 0;
  if (listaCorrectos.length === 0) return 2;
  if (!tieneOrden && listaCorrectos.length > 0) return 0;
  if (tieneOrden && listaCorrectos.length !== listTurnos) return 1;
};

const compararHoras = (hora1, hora2) => {
  // Separar la hora y los minutos de la primera hora
  let [hora1Actual, minutos1Actuales] = hora1.split(":").map(Number);

  // Separar la hora y los minutos de la segunda hora
  let [hora2Actual, minutos2Actuales] = hora2.split(":").map(Number);

  // Comparar las horas y los minutos
  if (
    hora1Actual > hora2Actual ||
    (hora1Actual === hora2Actual && minutos1Actuales > minutos2Actuales)
  ) {
    return true; // Primera hora es mayor que la segunda hora
  } else {
    return false; // Primera hora es menor o igual a la segunda hora
  }
};
const obtenerHoraActual = () => {
  // Obtener la hora y los minutos actuales
  let fechaActual = new Date();
  let horaActual = fechaActual.getHours();
  let minutosActuales = fechaActual.getMinutes();

  // Formatear la hora y los minutos
  let horaFormateada = horaActual.toString().padStart(2, "0");
  let minutosFormateados = minutosActuales.toString().padStart(2, "0");

  // Devolver la hora formateada
  return horaFormateada + ":" + minutosFormateados;
};
const sumarMinutos = (hora, minutos) => {
  // Separar la hora y los minutos
  let partes = hora.split(":");
  let horaActual = parseInt(partes[0]);
  let minutosActuales = parseInt(partes[1]);

  // Sumar los minutos
  let sumaTotalMinutos = minutosActuales + minutos;

  // Calcular el exceso de minutos y ajustar la hora si es necesario
  let excesoMinutos = Math.floor(sumaTotalMinutos / 60);
  let nuevosMinutos = sumaTotalMinutos % 60;
  let nuevaHora = (horaActual + excesoMinutos) % 24;

  // Formatear la nueva hora y minutos
  let horaFormateada = nuevaHora.toString().padStart(2, "0");
  let minutosFormateados = nuevosMinutos.toString().padStart(2, "0");

  // Devolver la hora formateada
  return horaFormateada + ":" + minutosFormateados;
};

export const OrderTurnos = (
  turnos,
  filtroHorario,
  minutosToleranciaRecepcion,
  minRecepcionVariosTurnos,
  isLabo
) => {
  let centroQR = sessionStorage.getItem("centroID");
  if (isLabo) turnos = turnos.filter((turno) => turno.idProtocolo);
  else turnos = turnos.filter((turno) => !turno.idProtocolo);
  if (isLabo) turnos = turnos.filter((turno) => turno.estadoProtocolo !== 4);

  turnos = turnos.map((turno) => {
    turno.selected = false;

    if (!turno?.checkin) turno.type = "noPermiteCheckIn";
    if (turno?.type === "noPermiteCheckIn" && turno?.kinesioVerificaRecepcion)
      turno.type = "kinesioVerificacion";
    if (turno?.type === "noPermiteCheckIn" && turno?.osValidacionInterna)
      turno.type = "osValidacionInterna";
    if (!turno?.type && turno?.idProtocolo) turno.type = "laboratorio";
    if (!turno?.type && turno?.flgSoloConsulta) turno.type = "consulta";
    if (!turno?.type && !turno?.flgSoloConsulta) turno.type = "practica";
    if (timeRecepcion(turno.hora, filtroHorario, minutosToleranciaRecepcion))
      turno.type = "fueraRangoHorario";
    return turno;
  });

  turnos = turnos.map((turno) => {
    if (turno.type !== "fueraRangoHorario") {
      if (
        timeRecepcion(
          turno.hora,
          minRecepcionVariosTurnos,
          minutosToleranciaRecepcion
        )
      )
        turno.type = "fueraRangoHorario";
    }
    return turno;
  });

  turnos = turnos.map((turno) => {
    if (turno.type === "fueraRangoHorario") {
      const isAusente = compararHoras(
        obtenerHoraActual(),
        sumarMinutos(turno.hora, minutosToleranciaRecepcion)
      );
      if (isAusente) turno.type = "ausente";
    }
    // ACA, COPIAR ESTO

    // Esta parte solo funciona en laboratorio
    if (
      turno.type !== "fueraRangoHorario" &&
      turno.estadoProtocolo > 1 &&
      turno.estadoProtocolo < 4
    ) {
      turno.selected = true;
    }
    if (!isLabo && turno.type !== "fueraRangoHorario") {
      if (turno.idCentro.toString() !== centroQR) {
        turno.selected = false;
      } else {
        turno.selected = true;
      }
    }
    return turno;
  });

  return turnos;
};

export function setItemWithExpiry(key, value) {
  const ttlMinutes = 30; // time to live
  const now = new Date();
  const expiryTime = now.getTime() + ttlMinutes * 60000; // 60000 ms = 1 minuto
  const item = {
    value: value,
    expiry: expiryTime,
  };
  sessionStorage.setItem(key, JSON.stringify(item));
}

export function getItemWithExpiry(key) {
  const itemStr = sessionStorage.getItem(key);
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  if (now.getTime() > item.expiry) {
    sessionStorage.removeItem(key);
    return null;
  }
  return item.value;
}

export const OrderTurnosLabo = (
  turnos,
  filtroHorario,
  minutosToleranciaRecepcion,
  minRecepcionVariosTurnos
) => {
  turnos = turnos.filter((turno) => turno.idProtocolo);
  const determinarTipoTurno = (turno) => {
    if (!turno?.checkin) return "noPermiteCheckIn";
    if (turno?.type === "noPermiteCheckIn" && turno?.osValidacionInterna)
      return "osValidacionInterna";
    if (!turno?.type && turno?.idProtocolo) return "laboratorio";
    if (timeRecepcion(turno.hora, filtroHorario, minutosToleranciaRecepcion))
      return "fueraRangoHorario";
    return turno.type;
  };
  turnos = turnos.map((turno) => ({
    ...turno,
    type: determinarTipoTurno(turno),
  }));

  turnos = turnos.map((turno) => {
    if (
      turno.type !== "fueraRangoHorario" &&
      timeRecepcion(
        turno.hora,
        minRecepcionVariosTurnos,
        minutosToleranciaRecepcion
      )
    ) {
      return { ...turno, type: "fueraRangoHorario" };
    }
    return turno;
  });

  turnos = turnos.map((turno) => {
    if (turno.type === "fueraRangoHorario") {
      const isAusente = compararHoras(
        obtenerHoraActual(),
        sumarMinutos(turno.hora, minutosToleranciaRecepcion)
      );
      if (isAusente) {
        return { ...turno, type: "ausente" };
      }
    } else if (turno.estadoProtocolo > 1 && turno.estadoProtocolo < 4) {
      return { ...turno, selected: true };
    }
    return turno;
  });

  return turnos;
};

export const turnosOrdenamiento = (
  turnos,
  filtroHorario,
  minutosToleranciaRecepcion,
  minRecepcionVariosTurnos
) => {
  let turnosRechazados = [];
  let turnosFueraHorario90 = [];
  let turnosFueraHorario = [];
  let turnosLabo = [];
  let turnosRecepcion = [];
  let turnosAusente = [];
  let turnosPracticas = [];

  turnos.map((turno) => {
    if (turno?.idProtocolo) turnosLabo.push(turno);
    if (!turno?.checkin) turnosRechazados.push(turno);
    if (turno.flgSoloPractica) turnosPracticas.push(turno);
    if (!turno?.idProtocolo && turno?.checkin) {
      if (
        !timeRecepcion(turno.hora, filtroHorario, minutosToleranciaRecepcion) &&
        !turno.flgSoloPractica
      ) {
        turnosRecepcion.push(turno);
      } else if (
        timeRecepcion(turno.hora, filtroHorario, minutosToleranciaRecepcion) &&
        !timeRecepcion(
          turno.hora,
          minRecepcionVariosTurnos,
          minutosToleranciaRecepcion
        )
      ) {
        turnosFueraHorario90.push(turno);
      } else if (
        timeRecepcion(turno.hora, filtroHorario, minRecepcionVariosTurnos)
      ) {
        turnosFueraHorario.push(turno);
      } else {
        turnosAusente.push(turno);
      }
    }
  });
  return {
    turnosRechazados,
    turnosFueraHorario90,
    turnosFueraHorario,
    turnosLabo,
    turnosRecepcion,
    turnosAusente,
    turnosPracticas,
  };
};
